module.exports = __webpack_public_path__ + "static/media/code.878c4de5.jpg";